import { RequestType } from "../models/request.model";

export const isThirdPartyRequest = (requestType?: RequestType): boolean => {
  return (
    requestType === RequestType.ThirdPartyOffice ||
    requestType === RequestType.PrescriptionRefill ||
    requestType === RequestType.DocnoteDebit ||
    requestType === RequestType.QuickFormOffice ||
    requestType === RequestType.WSIBOffice ||
    requestType === RequestType.ServiceCanadaOffice
  );
};
